import { useEffect, useMemo, useState } from "react";
import * as yup from "yup";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FerramentasDeDetalhe, SelectComponent } from "../../shered/components";
import { VForm, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import {    
    Box, Paper, Typography, useTheme    
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { ptBR } from '@mui/x-data-grid/locales';
import { FranquiaService, IDetalheFranquia, ILstDrop } from "../../shered/services/api/franquia/FranquiaService";
import { Loading } from "../../shered/components/loading/Loading";
import { UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { DraftService, IDetalheDraftPicksTable } from "../../shered/services/api/draft/DraftService";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";

const columns: GridColDef[] = [
    {
        field: 'id',
        headerName: 'ID',
        width: 90,
        headerClassName: 'super-app-theme--header'
    },
    {
        field: 'caminho_Logo_Franquia_Dono',
        headerName: 'Logo Dono',
        flex: 1,
        renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
        headerClassName: 'super-app-theme--header'
    },
    {
        field: 'nome_Franquia_Dono',
        headerName: 'Dono PICK',
        flex: 1,
        headerClassName: 'super-app-theme--header'
    },
    {
        field: 'caminho_Logo_Franquia_Original',
        headerName: 'Logo Orig.',
        flex: 1,
        renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined) ? <img src={params.value} width={45} height={50} /> : null,
        headerClassName: 'super-app-theme--header'
    },
    {
        field: 'nome_Franquia_Original',
        headerName: 'Origem PICK',
        flex: 1,
        headerClassName: 'super-app-theme--header'
    },

    {
        field: 'foto_Jogador_Escolhido',
        headerName: 'Foto',
        flex: 1,
        renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined) ? <img src={params.value} width={50} height={50} /> : null,
        headerClassName: 'super-app-theme--header'
    },
    {
        field: 'nome_Jogador_Escolhido',
        headerName: 'Nome Jogador',
        description: 'Nome do Jogador da Franquia escolido',
        sortable: false,
        flex: 1,
        headerClassName: 'super-app-theme--header',
        valueGetter: (params: GridValueGetterParams) =>
            `${params.row.nome_Jogador_Escolhido || ''}`,
    },
];

// const rows = [
//     { id: 1, donoPick: 'Snow', origemPick: '', nomeJogador: 'Jon', foto: "../../trofel_NBA_2.png" },
//     { id: 2, donoPick: 'Lannister', origemPick: '', nomeJogador: 'Cersei', foto: "../../trofel_NBA_2.png" },
//     { id: 3, donoPick: 'Lannister', origemPick: '', nomeJogador: 'Jaime', foto: "../../trofel_NBA_2.png" },
//     { id: 4, donoPick: 'Stark', origemPick: '', nomeJogador: 'Arya', foto: "../../trofel_NBA_2.png" },
//     { id: 5, donoPick: 'Targaryen', origemPick: '', nomeJogador: 'Daenerys', foto: "../../trofel_NBA_2.png" },
//     { id: 6, donoPick: 'Melisandre', origemPick: '', nomeJogador: null, foto: "../../trofel_NBA_2.png" },
//     { id: 7, donoPick: 'Clifford', origemPick: '', nomeJogador: 'Ferrara', foto: "../../trofel_NBA_2.png" },
//     { id: 8, donoPick: 'Frances', origemPick: '', nomeJogador: 'Rossini', foto: "../../trofel_NBA_2.png" },
//     { id: 9, donoPick: 'Roxie', origemPick: '', nomeJogador: 'Harvey', foto: "../../trofel_NBA_2.png" },
// ];



export const ListagemDraftPicks: React.FC = () => {
    const theme = useTheme();
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, logout } = useAuthContext();
    const [edicao, setEdicao] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [rows, setRows] = useState<IDetalheDraftPicksTable[]>([]);
    const [searchParams, SetSearchParams] = useSearchParams();
    const [redirecionar, setRedirecionar] = useState("0");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const { themeName } = useAppThemeContext();
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const pagina = useMemo(() => {
        return Number(searchParams.get("pagina") || "1");
    }, [searchParams]);

    useEffect(() => {
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });

            setRedirecionar("/dashboard");
            return;
        }
        else {
            setIsLoading(true);
            const fetchData = async () => {
                setIsLoading(false);
                setRemoveLoading(true);
                await UtilidadeService.getTemporadas(true, Number(codigoLiga))
                    .then((result) => {
                        setIsLoading(false);
                        const tmps = result.data.dado;
                        let lstTemporadasAux = result.data.dado.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                        setLstTemporadas(lstTemporadasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        if (errors.response.status === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    });
                await DraftService.getBuscarPicksDraft(pagina, Number(codigoLiga), 1)
                    .then((result) => {
                        setIsLoading(false);
                        const drafts = result.data.dado;
                        const newDrafts = drafts.map((m, i) => ({
                            id: i + 1,
                            codigo: m.codigo,
                            caminho_Logo_Franquia_Dono: m.caminho_Logo_Franquia_Dono,
                            nome_Franquia_Dono: m.nome_Franquia_Dono,
                            caminho_Logo_Franquia_Original: m.caminho_Logo_Franquia_Original,
                            nome_Franquia_Original: m.nome_Franquia_Original,
                            foto_Jogador_Escolhido: m.foto_Jogador_Escolhido,
                            nome_Jogador_Escolhido: m.nome_Jogador_Escolhido,
                            codigo_Franquia_Original: m.codigo_Franquia_Original,
                            codigo_Franquia_Dono: m.codigo_Franquia_Dono,
                            codigo_Temporada: m.codigo_Temporada,
                            rodada: m.rodada,
                            posicao_Final: m.posicao_Final
                        }));
                        setRows(newDrafts);
                        formRef.current?.setFieldValue("configuracao_Liga.codigo_Temporada", Number(drafts.pop()?.codigo_Temporada));
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        if (errors.response.status === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    });

            }
            fetchData();
        }
    }, [pagina, codigoLiga]);

    const handleSave = async (dados: IDetalheFranquia) => {
        setIsLoading(true);
        setIsLoading(false);

    };

    const handleDelete = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            FranquiaService.deleteById(id)
                .then((result) => {
                    setShowModalMensagem(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Registro excluido com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar("/franquias");
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }
    };

    const handleSelectedTemporada = async (e: { target: { name: string; value: any; }; }) => {
        await DraftService.getBuscarPicksDraft(pagina, Number(codigoLiga), e.target.value)
            .then((result) => {
                setIsLoading(false);
                const drafts = result.data.dado;
                setRows(drafts);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
            });
    };

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    };

    return (
        <LayoutBaseDePagina
            titulo="Lista de Picks"
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoSalvar={false}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmVoltar={() => navigate(`/usuario/liga/${codLocal}`)}
                />
            }
        >
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={2} spacing={2}>
                        <Grid  size={{xs:12, sm:12}} >
                            <Typography variant="h6">Lista de Picks</Typography>
                            <hr />
                        </Grid>
                        <Grid container size={{xs:12, sm:12}} display="flex" justifyContent="initial">
                            <Grid  size={{xs:12, sm:6, md:3}} >
                                <SelectComponent
                                    required
                                    isExternalLoading={isLoading || edicao}
                                    label="Temporadas"
                                    name="configuracao_Liga.codigo_Temporada"
                                    items={lstTemporadas}
                                    defaultValue=""
                                    variant="outlined"
                                    onChange={handleSelectedTemporada}
                                />
                            </Grid>
                        </Grid>
                        {!removeLoading && <Loading />}
                        <Grid  size={{xs:12, sm:12}} sx={{ width: "100%" }}   >
                            <Box sx={{
                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                '& .super-app-theme--header': {
                                    backgroundColor: theme.palette.common.black,
                                    color: theme.palette.common.white
                                },
                                '& .super-app.negative': {
                                    color: 'red',
                                    fontWeight: 'bold'
                                },
                                '& .super-app.positive': {
                                    color: themeName === "light" ? "black" : "auto",
                                },
                            }}>
                                <DataGrid
                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                    autoHeight
                                    getRowId={(rows) => rows.codigo}
                                    rows={rows}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 8,
                                                page: pagina,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[8]}
                                    //checkboxSelection
                                    disableRowSelectionOnClick
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    );
}